var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vaimo-ratio-wrapper"},[_c('div',{staticClass:"relative",class:_vm.transformedRatioClass},[(_vm.$slots.image)?[_vm._t("image")]:_vm._e(),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }